import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';

interface DeleteConfigurationDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Conferma eliminazione configurazione. Copy portata 1:1 dal legacy
 * (InfoPopup.WarningDeleteConfigurationContent).
 */
export function DeleteConfigurationDialog({ open, onCancel, onConfirm }: DeleteConfigurationDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogContent sx={{ textAlign: 'center', pt: 4 }}>
        <Typography variant="h4" color="primary" sx={{ mb: 2 }}>
          ATTENZIONE!
        </Typography>
        <Typography sx={{ fontStyle: 'italic', mb: 2 }}>
          Eliminando questa opzione, verranno annullate tutte le scelte effettuate dentro la
          configurazione.
        </Typography>
        <Typography sx={{ fontWeight: 600 }}>
          SEI SICURO DI VOLER{' '}
          <Box component="span" sx={{ color: 'primary.main' }}>
            ELIMINARE QUESTA CONFIGURAZIONE?
          </Box>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 1, pb: 3 }}>
        <Button variant="outlined" color="inherit" onClick={onCancel}>
          <strong>NO</strong>,&nbsp;voglio mantenere
        </Button>
        <Button variant="contained" color="primary" onClick={onConfirm}>
          <strong>SI</strong>,&nbsp;voglio eliminare
        </Button>
      </DialogActions>
    </Dialog>
  );
}
